var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 10,
  viewBox: "0 0 16 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 9V0H2V9H0V10H2H14H16V9H14ZM3 9V1H13V9H3Z",
  fill: "#E00C69"
})));
export { SvgDesktop as ReactComponent };
export default __webpack_public_path__ + "assets/icons/desktop.1e122c.svg";